import React from "react";
import PropTypes from "prop-types";

const SafetyAwardIcon = ({ fill, width, height, boxShadow }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 84 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M42 0H84V42V63L42 84L0 63V42V0H42Z" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.786 19.95C41.786 19.95 38.3462 26.4131 25.275 26.4131C25.275 26.4131 24.5945 39.7688 27.3389 46.111C30.9708 54.5045 41.786 56.9789 41.786 56.9789C41.786 56.9789 52.6012 54.5045 56.2332 46.111C58.9776 39.7688 58.2971 26.4131 58.2971 26.4131C44.5379 26.4131 41.786 19.95 41.786 19.95ZM39.8605 45.4919V41.733H36.1015V37.974H39.8605V34.2147H43.6195V37.974H47.3786V41.733H43.6195V45.4919H39.8605Z"
        fill="white"
      />
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="84"
        height="84"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M84 0H42H0V21H84V0ZM84 63V52.5H0V63L42 84L84 63Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.4 8.4V57.9032L42 74.7032L75.6 57.9032V8.4H8.4ZM78.75 59.85L42 78.225L5.25 59.85V5.25H78.75V59.85Z"
          fill="white"
        />
      </g>
      <path
        d="M8.4002 28.35L6.3002 31.5L4.2002 28.35L6.3002 25.2L8.4002 28.35Z"
        fill="white"
      />
      <path
        d="M8.4002 45.15L6.3002 48.3L4.2002 45.15L6.3002 42L8.4002 45.15Z"
        fill="white"
      />
      <path
        d="M79.7996 28.35L77.6996 31.5L75.5996 28.35L77.6996 25.2L79.7996 28.35Z"
        fill="white"
      />
      <path
        d="M79.7996 45.15L77.6996 48.3L75.5996 45.15L77.6996 42L79.7996 45.15Z"
        fill="white"
      />
      <path
        d="M6.35254 31.5L10.29 36.5806L6.35254 42L2.41504 36.5806L6.35254 31.5Z"
        fill="white"
      />
      <path
        d="M77.752 31.5L81.6895 36.5806L77.752 42L73.8145 36.5806L77.752 31.5Z"
        fill="white"
      />
    </svg>
  );
};

SafetyAwardIcon.propTypes = {
  /**
   * The color of the award icon
   * Can be any CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
   */
  fill: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  boxShadow: PropTypes.bool
};

SafetyAwardIcon.defaultProps = {
  width: "75%",
  height: 114,
  boxShadow: true
};

export default SafetyAwardIcon;
